import { render, staticRenderFns } from "./MarketTypeList.vue?vue&type=template&id=45fc9daa"
import script from "./MarketTypeList.vue?vue&type=script&lang=js"
export * from "./MarketTypeList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports